import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

export default {
    name: 'podcastpreview',
    props: {
        podcast : Object,
        lessonNumber : Number
    },

    components : {
    },

    data : function(){

        return {
            loading : false
        }

    },

    created () {
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        ageCluster : function(){
            return f.findCluster(this.podcast.age, f.deep(this.core, 'appInfo.snippity.settings.ageClusters') || [])
        },
        auth : state => state.auth,
    }),

    methods : {
        click : function(){
            this.$router.push('/podcasts/' + this.podcast.uid)
        }
    },
}